import React from 'react';
import { useNavigate } from 'react-router-dom';
import MeetingCard from './MeetingCard';
import OverviewBoardHeader from './board/OverviewBoardHeader';
import './styles/UpcomingAppointmentsCard.css';
import './board/OverviewBoard.css';

const UpcomingMeetingsCard = ({ meetings, onMeetingClick }) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate('/app/overview/meetings/list');
  };

  return (
    <div className="upcoming-appointments-container overview-board">
      <OverviewBoardHeader
        eyebrow="Upcoming"
        title="Meetings"
        count={`${meetings?.length || 0} scheduled`}
        actionLabel="View"
        onAction={handleViewAll}
        actionTitle="View all meetings"
      />

      <div className="upcoming-appointments-content">
        {meetings && meetings.length > 0 ? (
          <div className="upcoming-appointments-grid">
            {meetings.map((meeting) => (
              <div key={meeting.id}>
                <MeetingCard
                  meeting={meeting}
                  onClick={onMeetingClick}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="upcoming-appointments-empty">
            <p>No upcoming meetings</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpcomingMeetingsCard;

